import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Headset } from "lucide-react";
import { UsuarioContext } from "../../../providers/userContext";
import useResumenChatEliteStaff, { contadorMenuChatElite } from "../../../hooks/useResumenChatEliteStaff";
import { CHAT_ELITE_VISIBLE } from "../../../utilities/chatEliteUsuario";
import { useContadorFavicon } from "../../../utilities/faviconContador";
import "./BotonNavChatElite.css";

const ROLES = ["ADMIN", "CONSUL", "VENT"];

/**
 * Acceso al Chat Elite en la barra superior (a la izquierda del idioma) para ADMIN, CONSUL y VENT,
 * con el numero de consultas que requieren atencion (mismo icono que el widget del AAFF).
 */
const BotonNavChatElite = ({ movil = false }) => {
  const { t } = useTranslation("common");
  const user = useContext(UsuarioContext);
  const resumen = useResumenChatEliteStaff();
  const permitido = CHAT_ELITE_VISIBLE && ROLES.includes(user?.rol);
  const numero = permitido ? contadorMenuChatElite(resumen, user.rol === "VENT") : 0;
  // El mismo número en el favicon (arriba a la derecha), para verlo desde otra pestaña
  useContadorFavicon(numero);
  if (!permitido) return null;

  const etiqueta = numero > 0
    ? `${t("chatElite.widget.titulo")} · ${t("chatElite.panel.pendientesMenu", { count: numero })}`
    : t("chatElite.widget.titulo");

  return (
    <NavLink
      to="/chat-elite"
      className={({ isActive }) => `ce-nav-boton ${movil ? "ce-nav-boton--movil" : ""} ${isActive ? "ce-nav-boton--activo" : ""}`}
      aria-label={etiqueta}
      title={etiqueta}
    >
      <Headset size={movil ? 18 : 19} strokeWidth={1.8} />
      {numero > 0 && <span className="ce-nav-boton__badge">{numero > 99 ? "99+" : numero}</span>}
    </NavLink>
  );
};

export default BotonNavChatElite;
